<template>
  <div id="content-page" class="content-page">
    <div class="iq-top-navbar">
      <div class="iq-navbar-custom">
        <nav class="navbar navbar-expand-lg navbar-light p-0">
          <router-link v-if="!isGalatea" :to="homeURL">
            <img v-if="defaultAvatarLogo" :src="fileLogo" class="top-logo" />
            <img v-else class="top-logo" v-bind:src="'data:image/jpeg;base64,' + fileLogo" />
          </router-link>
        </nav>
      </div>
    </div>
    <b-row>
      <b-col>
        <b-container fluid>
          <iq-card>
            <template v-slot:headerTitle class="w--100">
              <h4 class="card-title float-left title-typography-color">
                <i class="fas fa-file"></i>
                {{ $t("public.views.Pages.Wizard.title") }}
              </h4>
            </template>
            <template v-slot:body>
              <form-wizard :subtitle="subtitleWizard" :title="titleWizard" color="#0cb0c2" shape="square">
                <tab-content :title="tab1TitleWizard" icon="fas fa-user">
                  <b-form>
                    <b-form-group label-for="email">
                      <template slot="label">{{ $t("public.views.Pages.Wizard.step1.email") }}:
                        *
                      </template>
                      <b-form-input id="email" v-model="email" :disabled="true" type="text"></b-form-input>
                    </b-form-group>
                    <b-form-group label-for="name">
                      <template slot="label">{{ $t("public.views.Pages.Wizard.step1.name") }}:
                        *
                      </template>
                      <b-form-input id="nombre" v-model="name" type="text" v-bind:class="{
                        'text-danger': isFormNameErrors,
                        'is-invalid': isFormNameErrors,
                      }" @blur="checkName(name)"></b-form-input>
                      <ul v-if="isFormNameErrors">
                        <li v-for="(error, index) in validatorStep2.getErrors(
                          'name'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label-for="lastname">
                      <template slot="label">{{ $t("public.views.Pages.Wizard.step1.lastname") }}:
                        *
                      </template>
                      <b-form-input id="lastname" v-model="lastname" type="text" v-bind:class="{
                        'text-danger': isFormLastnameErrors,
                        'is-invalid': isFormLastnameErrors,
                      }" @blur="checkLastname(lastname)"></b-form-input>
                      <ul v-if="isFormLastnameErrors">
                        <li v-for="(error, index) in validatorStep2.getErrors(
                          'lastname'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label-for="password">
                      <template slot="label">{{ $t("public.views.Pages.Wizard.step1.pwd") }}:
                        *
                      </template>
                      <b-form-input id="password" v-model="password" type="password" v-bind:class="{
                        'text-danger': isFormPasswordErrors,
                        'is-invalid': isFormPasswordErrors,
                      }" @blur="checkPassword(password)"></b-form-input>
                      <ul v-if="isFormPasswordErrors">
                        <li v-for="(error, index) in validatorStep1.getErrors(
                          'password'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label-for="passwordConfirm">
                      <template slot="label">{{ $t("public.views.Pages.Wizard.step1.pwdConfirm") }}:
                        *
                      </template>
                      <b-form-input id="passwordConfirm" v-model="passwordConfirm" type="password" v-bind:class="{
                        'text-danger': isFormPasswordConfirmErrors,
                        'is-invalid': isFormPasswordConfirmErrors,
                      }" @blur="checkPasswordConfirm(passwordConfirm, password)"></b-form-input>
                      <ul v-if="isFormPasswordConfirmErrors">
                        <li v-for="(error, index) in validatorStep1.getErrors(
                          'passwordConfirm'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label-for="document">
                      <template slot="label">{{ $t("public.views.Pages.Wizard.step2.document") }}: *
                      </template>
                      <b-form-input id="document" v-model="document" type="text" v-bind:class="{
                        'text-danger': isFormDocumentErrors,
                        'is-invalid': isFormDocumentErrors,
                      }" @blur="checkDocument(document)"></b-form-input>
                      <ul v-if="isFormDocumentErrors">
                        <li v-for="(error, index) in validatorStep2.getErrors(
                          'document'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group>
                      <template slot="label">{{
                        $t("public.views.Pages.Wizard.step2.image")
                      }}
                      </template>
                      <vue-dropzone id="picture" :options="dropzoneOptions"
                        @vdropzone-success="vdropzoneSuccess"></vue-dropzone>
                    </b-form-group>

                    <div class="col-md-4 img-center">
                      <img v-if="defaultAvatar" :src="file" class="img-fluid rounded mr-3" height="150px" width="150px" />
                      <img v-else class="img-fluid rounded mr-3" height="150px"
                        v-bind:src="'data:image/jpeg;base64,' + file" width="150px" />
                    </div>
                    <b-form-group label-for="idioma">
                      <template slot="label">{{ $t("public.views.Pages.Wizard.step2.lenguage") }}:
                      </template>
                      <b-select id="language" v-model="language" :options="languageSelect" class="form-control"
                        v-bind:class="{
                          'text-danger': isFormLanguageErrors,
                          'is-invalid': isFormLanguageErrors,
                        }">
                      </b-select>
                      <ul v-if="isFormLanguageErrors">
                        <li v-for="(error, index) in validatorStep2.getErrors(
                          'language'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label-for="phone">
                      <template slot="label">{{
                        $t("public.views.Pages.Wizard.step2.tlf")
                      }}:
                      </template>
                      <VuePhoneNumberInput id="phoneVuePhoneNumberInput" v-model="phoneVuePhoneNumberInput"
                        :disabled="disabled" :translations="translations" default-country-code="ES" v-bind:class="{
                          'text-danger': isFormPhoneErrors,
                          'is-invalid': isFormPhoneErrors,
                        }" @update="updatePhone" />
                      {{ phone }}
                      <ul v-if="isFormPhoneErrors">
                        <li v-for="(error, index) in validatorStep2.getErrors(
                          'phone'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label-for="address">
                      <template slot="label">{{ $t("public.views.Pages.Wizard.step2.address") }}:
                      </template>
                      <b-form-input id="address" v-model="address" type="text"></b-form-input>
                    </b-form-group>
                    <b-form-group label-for="town">
                      <template slot="label">{{ $t("public.views.Pages.Wizard.step2.town") }}:
                      </template>
                      <b-form-input id="town" v-model="town" type="text"></b-form-input>
                    </b-form-group>
                    <b-form-group label-for="postalCode">
                      <template slot="label">{{ $t("public.views.Pages.Wizard.step2.postalCode") }}:
                      </template>
                      <b-form-input id="postalCode" v-model="postalCode" type="text"></b-form-input>
                    </b-form-group>
                    <b-form-group label-for="country">
                      <template slot="label">{{ $t("public.views.Pages.Wizard.step2.country") }}: *
                      </template>
                      <b-form-input id="country" v-model="country" type="text" v-bind:class="{
                        'text-danger': isFormCountryErrors,
                        'is-invalid': isFormCountryErrors,
                      }" @blur="checkCountry(country)"></b-form-input>
                      <ul v-if="isFormCountryErrors">
                        <li v-for="(error, index) in validatorStep2.getErrors(
                          'country'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label-for="timeZone">
                      <template slot="label">{{ $t("public.views.Pages.Wizard.step2.timeZone") }}: *
                      </template>
                      <b-select id="timeZone" v-model="timeZone" :options="timeZoneSelect" class="form-control"
                        v-bind:class="{
                          'text-danger': isFormTimeZoneErrors,
                          'is-invalid': isFormTimeZoneErrors,
                        }" @blur="checkTimeZone(country)">
                      </b-select>
                      <ul v-if="isFormTimeZoneErrors">
                        <li v-for="(error, index) in validatorStep2.getErrors(
                          'timeZone'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group v-if="isGalatea && wizardType === 'PATIENT'" label-for="cip">
                      <template slot="label">{{ $t("public.views.Pages.Wizard.step2.cipGalatea") }}:
                        *
                      </template>
                      <b-form-input id="cipGalatea" v-model="cipGalatea" class="form-control" v-bind:class="{
                        'text-danger': isFormCipGalateaErrors,
                        'is-invalid': isFormCipGalateaErrors,
                      }" @blur="checkCipGalatea(cipGalatea)">
                      </b-form-input>
                      <ul v-if="isFormCipGalateaErrors">
                        <li v-for="(error, index) in validatorStep2.getErrors(
                          'cipGalatea'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group v-if="!isGalatea || wizardType !== 'PATIENT'" label-for="acceptConditions1">
                      <template slot="label"></template>
                      <b-form-checkbox id="acceptConditions1" v-model="acceptConditions1" unchecked-value="false"
                        value="true" @blur="checkAcceptConditions1(acceptConditions1)">
                        {{
                          $t(
                            "public.views.Pages.Wizard.step2.acceptConditions1"
                          )
                        }}
                        <a class="cursor-point title-typography-color-important">{{
                          $t(
                            "public.views.Pages.Wizard.step2.acceptConditions11"
                          )
                        }}</a>
                      </b-form-checkbox>
                      <ul v-if="isFormAcceptConditionsErrors1">
                        <li v-for="(error, index) in validatorStep2.getErrors(
                          'acceptConditions1'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group v-if="isGalatea && wizardType === 'PATIENT'" label-for="acceptConditionsGalatea1">
                      <template slot="label"></template>
                      <b-form-checkbox id="acceptConditionsGalatea1" v-model="acceptConditionsGalatea1"
                        unchecked-value="false" value="true" @blur="
                          checkAcceptConditionsGalatea1(
                            acceptConditionsGalatea1
                          )
                        ">
                        {{
                          $t(
                            "public.views.Pages.Wizard.step2.acceptConditionsGalatea1"
                          )
                        }}
                      </b-form-checkbox>
                      <a class="cursor-point title-typography-color-important" @click="downloadInformationGalatea">{{
                        $t(
                          "public.views.Pages.Wizard.step2.acceptConditionsGalatea11"
                        )
                      }}</a>
                      <ul v-if="isFormAcceptConditionsErrorsGalatea1">
                        <li v-for="(error, index) in validatorStep2.getErrors(
                          'acceptConditionsGalatea1'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group v-if="isGalatea && wizardType === 'PATIENT'" label-for="acceptConditionsGalatea2" @blur="
                      checkAcceptConditionsGalatea2(acceptConditionsGalatea2)
                    ">
                      <template slot="label"></template>
                      <b-form-checkbox id="acceptConditionsGalatea2" v-model="acceptConditionsGalatea2"
                        unchecked-value="false" value="true">
                        {{
                          $t(
                            "public.views.Pages.Wizard.step2.acceptConditionsGalatea2"
                          )
                        }}
                      </b-form-checkbox>
                      <a class="cursor-point title-typography-color-important" @click="downloadLegalGalatea">{{
                        $t(
                          "public.views.Pages.Wizard.step2.acceptConditionsGalatea22"
                        )
                      }}</a>
                      <ul v-if="isFormAcceptConditionsErrorsGalatea2">
                        <li v-for="(error, index) in validatorStep2.getErrors(
                          'acceptConditionsGalatea2'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group v-if="isGalatea && wizardType === 'PATIENT'" label-for="acceptConditionsGalatea3">
                      <template slot="label"></template>
                      <b-form-checkbox id="acceptConditionsGalatea3" v-model="acceptConditionsGalatea3"
                        unchecked-value="false" value="true" @blur="
                          checkAcceptConditionsGalatea3(
                            acceptConditionsGalatea3
                          )
                        ">
                        {{
                          $t(
                            "public.views.Pages.Wizard.step2.acceptConditionsGalatea3"
                          )
                        }}
                      </b-form-checkbox>
                      <ul v-if="isFormAcceptConditionsErrorsGalatea3">
                        <li v-for="(error, index) in validatorStep2.getErrors(
                          'acceptConditionsGalatea3'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                  </b-form>
                </tab-content>
                <template slot="footer" slot-scope="props">
                  <div class="wizard-footer-right">
                    <wizard-button :style="props.fillButtonStyle" class="wizard-footer-right finish-button"
                      @click.native="saveForm">{{
                        props.isLastStep
                        ? $t("public.views.Pages.Wizard.btn.finish")
                        : $t("public.views.Pages.Wizard.btn.step1")
                      }}
                    </wizard-button>
                  </div>
                </template>
              </form-wizard>
            </template>
          </iq-card>
        </b-container>
      </b-col>
    </b-row>
    <FooterStyle>
      <template v-slot:left>
        <ul>
          <li v-for="(item, index) in footer.footerLanguages" :key="index" class="list-inline-item">
            <a class="cursor-point" @click="openItem(index)">{{ item.title.content }} </a><span
              v-if="index < footer.footerLanguages.length - 1"> | </span>
            <b-modal :id="'modal-' + index" :title="item.title.content" centered hide-header-close ok-only size="xl">
              <p v-html="item.content.content"></p>
            </b-modal>
          </li>
        </ul>
      </template>
      <template v-slot:right>
        Copyright 2021
        <a v-if="!isGalatea" href="#">CITA.IO</a>
      </template>
    </FooterStyle>

    <b-modal :id="'modal-conditions-galatea1'" :title="$t('public.views.Pages.Wizard.step2.acceptConditionsLegalTitle')"
      centered hide-header-close ok-only size="xl">
      <p v-html="
        $t('public.views.Pages.Wizard.step2.acceptConditionsLegalContent')
      "></p>
    </b-modal>

    <b-modal :id="'modal-conditions-galatea2'" :title="
      $t('public.views.Pages.Wizard.step2.acceptConditionsInformationTitle')
    " centered hide-header-close ok-only size="xl">
      <p v-html="
        $t(
          'public.views.Pages.Wizard.step2.acceptConditionsInformationContent'
        )
      "></p>
    </b-modal>

    <notifications group="notificacions" />
  </div>
</template>

<script>
import routes from "../../router/index";
import TimeZone from "../../services/timeZone";
import Language from "../../json/Language";
import Currency from "../../json/Currency";

import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import validator from "vue-m-validator";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import FooterSign from "../../components/xray/footer/FooterSign";

import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

import patientService from "../../services/patient";
import professionalService from "../../services/professional";
import utilsService from "../../services/utils";
import organizationService from "../../services/organization";
import authService from "../../services/auth";
import footerService from "../../services/footer";

export default {
  name: "WizardPublic",
  components: {
    FooterSign,
    FormWizard,
    TabContent,
    WizardButton,
    VuePhoneNumberInput,
    "vue-dropzone": vue2Dropzone,
  },
  computed: {
    //Form step 1
    isFormEmailErrors() {
      const RULE_2_REGEXP = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      );
      if (RULE_2_REGEXP.test(this.email)) {
        this.getCheckEmail(this.email);
      }
      let errors = this.validatorStep1.getErrors("email");
      return errors && errors.length > 0;
    },
    isFormNameErrors() {
      let errors = this.validatorStep1.getErrors("name");
      return errors && errors.length > 0;
    },
    isFormLastnameErrors() {
      let errors = this.validatorStep1.getErrors("lastname");
      return errors && errors.length > 0;
    },
    isFormPasswordErrors() {
      let errors = this.validatorStep1.getErrors("password");
      return errors && errors.length > 0;
    },
    isFormPasswordConfirmErrors() {
      let errors = this.validatorStep1.getErrors("passwordConfirm");
      return errors && errors.length > 0;
    },
    isFormAcceptConditionsErrors() {
      let errors = this.validatorStep1.getErrors("acceptConditions");
      return errors && errors.length > 0;
    },
    //Form 2
    isFormLanguageErrors() {
      let errors = this.validatorStep2.getErrors("language");
      return errors && errors.length > 0;
    },
    isFormPhoneErrors() {
      let errors = this.validatorStep2.getErrors("phone");
      return errors && errors.length > 0;
    },
    isFormDocumentErrors() {
      let errors = this.validatorStep2.getErrors("document");
      return errors && errors.length > 0;
    },
    isFormCountry() {
      let errors = this.validatorStep2.getErrors("country");
      return errors && errors.length > 0;
    },
    isFormTimeZone() {
      let errors = this.validatorStep2.getErrors("timeZone");
      return errors && errors.length > 0;
    },
    isFormDocument() {
      let errors = this.validatorStep2.getErrors("document");
      return errors && errors.length > 0;
    },
    isFormCipGalateaErrors() {
      let errors = this.validatorStep2.getErrors("cipGalatea");
      return errors && errors.length > 0;
    },
    isFormAcceptConditionsErrors1() {
      let errors = this.validatorStep1.getErrors("acceptConditions1");
      return errors && errors.length > 0;
    },
    isFormAcceptConditionsErrorsGalatea1() {
      let errors = this.validatorStep1.getErrors("acceptConditionsGalatea1");
      return errors && errors.length > 0;
    },
    isFormAcceptConditionsErrorsGalatea2() {
      let errors = this.validatorStep1.getErrors("acceptConditionsGalatea2");
      return errors && errors.length > 0;
    },
    isFormAcceptConditionsErrorsGalatea3() {
      let errors = this.validatorStep1.getErrors("acceptConditionsGalatea3");
      return errors && errors.length > 0;
    },
    isFormCountryErrors() {
      let errors = this.validatorStep2.getErrors("country");
      return errors && errors.length > 0;
    },
    isFormAddressErrors() {
      let errors = this.validatorStep2.getErrors("address");
      return errors && errors.length > 0;
    },
    isFormPostalCodeErrors() {
      let errors = this.validatorStep2.getErrors("postalCode");
      return errors && errors.length > 0;
    },
    isFormTownErrors() {
      let errors = this.validatorStep2.getErrors("town");
      return errors && errors.length > 0;
    },
    isFormTimeZoneErrors() {
      let errors = this.validatorStep2.getErrors("timeZone");
      return errors && errors.length > 0;
    },
    isFormCurrencyErrors() {
      let errors = this.validatorStep2.getErrors("currency");
      return errors && errors.length > 0;
    },
  },
  mounted() {
    this.initPatient();
    this.getLogoOrganization();
    this.getAllFooter();
  },
  data() {
    return {
      isGalatea: false,
      footer: [],
      wizardType: this.$route.query.wizardType,
      homeURL: {
        type: Object,
        default: () => ({
          name: "public.singin",
        }),
      },
      // Customize
      titleWizard: this.$i18n.t(
        "public.views.Pages.Wizard.help.tab.tab1.title"
      ),
      subtitleWizard: this.$i18n.t(
        "public.views.Pages.Wizard.help.tab.tab1.subtitle"
      ),
      tab1TitleWizard: this.$i18n.t(
        "public.views.Pages.Wizard.help.tab.tab1.name"
      ),
      tab2TitleWizard: this.$i18n.t(
        "public.views.Pages.Wizard.help.tab.tab2.name"
      ),
      isFirstRun: true,

      disabled: false,
      //Form
      email: this.$route.query.email,
      name: "",
      lastname: "",
      password: "",
      passwordConfirm: "",
      acceptConditions: "false",

      //Form 2

      file: "",
      defaultAvatar: true,
      uuid: "",
      document: "",
      //Form image
      dropzoneOptions: {
        url: process.env.VUE_APP_BASE_URL_CORE + "public/avatar/upload",
        thumbnailWidth: 200,
        maxFilesize: 2,
        addRemoveLinks: true,
        maxFiles: 1,
        dictDefaultMessage: "<i class='ri-upload-cloud-fill'></i>Subir",
      },
      language: "sp",
      phoneVuePhoneNumberInput: "",
      phone: "",
      country: "",
      address: "",
      timeZone: "Europe/Brussels",
      currency: "EUR",
      acceptConditions1: "false",

      //GALATEA
      acceptConditionsGalatea1: "false",
      acceptConditionsGalatea2: "false",
      acceptConditionsGalatea3: "false",
      cipGalatea: "",

      //Phone
      translations: {
        countrySelectorLabel: this.$i18n.t(
          "generic.phone.countrySelectorLabel"
        ),
        countrySelectorError: this.$i18n.t(
          "generic.phone.countrySelectorError"
        ),
        phoneNumberLabel: this.$i18n.t("generic.phone.phoneNumberLabel"),
        example: this.$i18n.t("generic.phone.example"),
      },

      //Global
      validatorStep1: validator,
      validatorStep2: validator,

      //Select
      timeZoneSelect: TimeZone,
      currencySelect: Currency,
      languageSelect: Language,

      // Navbar
      defaultAvatarLogo: true,
      fileLogo: "",
    };
  },
  methods: {
    downloadLegalGalatea() {
      this.$bvModal.show("modal-conditions-galatea1");
    },
    downloadInformationGalatea() {
      this.$bvModal.show("modal-conditions-galatea2");
    },
    getAllFooter() {
      let self = this;

      this.$awn.asyncBlock(
        footerService.getAllPublic(),
        (response) => {
          if (response) {
            self.footer = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "footerService.getAllPublic",
            module: "view-pages-wizard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null
          });
        },
        " "
      );
    },
    openItem(id) {
      this.$bvModal.show("modal-" + id);
    },
    openModal(id) {
      this.$bvModal.show(id);
    },
    initPatient() {
      if (this.wizardType && this.wizardType === "PATIENT") {
        if (this.$route.query.theme && this.$route.query.theme === "GALATEA") {
          this.isGalatea = true;
          this.titleWizard = this.$i18n.t(
            "public.views.Pages.Wizard.galatea.title"
          );
        }
        if (this.$route.query.name) {
          this.name = this.$route.query.name;
        }
        if (this.$route.query.lastname) {
          this.lastname = this.$route.query.lastname;
        }
        if (this.$route.query.document) {
          this.document = this.$route.query.document;
        }
        if (this.$route.query.language) {
          this.language = this.$route.query.language;
        }
        if (this.$route.query.phone) {
          this.phoneVuePhoneNumberInput = "+" + this.$route.query.phone;
          this.phone = "+" + this.$route.query.phone;
        }
        if (this.$route.query.country) {
          this.country = this.$route.query.country;
        }
        if (this.$route.query.address) {
          this.address = this.$route.query.address;
        }
        if (this.$route.query.timeZone) {
          this.timeZone = this.$route.query.timeZone;
        }
        if (this.$route.query.birthday) {
          this.birthday = this.$route.query.birthday;
        }
        if (this.$route.query.mutua) {
          this.mutua = this.$route.query.mutua;
        }
        if (this.$route.query.city) {
          this.city = this.$route.query.city;
        }
        if (this.$route.query.province) {
          this.province = this.$route.query.province;
        }
        if (this.$route.query.postalCode) {
          this.postalCode = this.$route.query.postalCode;
        }
        if (this.$route.query.town) {
          this.town = this.$route.query.town;
        }
        if (this.$route.query.uuid) {
          this.uuid = this.$route.query.uuid;
          this.getFile(this.uuid);
        } else {
          this.getFile("");
        }
        if (this.$route.query.filename) {
          this.filename = this.$route.query.filename;
        }
        if (this.$route.query.avatar) {
          this.avatar = this.$route.query.avatar;
        }
      } else {
        //get File avatar professional
        this.getFile("");
      }
    },
    notFirst() {
      this.isFirstRun = false;
    },
    //Form 1
    clickStep2(props) {
      this.checkFormStep1();
      if (this.validatorStep1.errors.length === 0) {
        //Call service to store data
        this.titleWizard = this.$i18n.t(
          "public.views.Pages.Wizard.help.tab.tab2.title"
        );
        this.subtitleWizard = this.$i18n.t(
          "public.views.Pages.Wizard.help.tab.tab2.subtitle"
        );
        props.nextTab();
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t("public.views.Pages.Wizard.errors.erTitle"),
          text: this.$i18n.t("public.views.Pages.Wizard.errors.erStep1"),
          type: "error",
        });
      }
    },
    checkEmail(_email) {
      const EMAIL = _email.trim();
      const RULE_1 = {
        expression: !EMAIL || EMAIL === "",
        name: "email",
        msg: this.$i18n.t("public.views.Pages.Wizard.errors.erEmail1"),
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      );
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(EMAIL),
        name: "email",
        msg: this.$i18n.t("public.views.Pages.Wizard.errors.erEmail2"),
      };
      this.validatorStep1.addRule(RULE_1).addRule(RULE_2);
      this.notFirst();
    },
    checkName(_name) {
      const NAME = _name.trim();
      const RULE_1 = {
        expression: !NAME || NAME === "",
        name: "name",
        msg: this.$i18n.t("public.views.Pages.Wizard.errors.erName"),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkLastname(_lastname) {
      const LASTNAME = _lastname.trim();
      const RULE_1 = {
        expression: !LASTNAME || LASTNAME === "",
        name: "lastname",
        msg: this.$i18n.t("public.views.Pages.Wizard.errors.erLastName"),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkPassword(_password) {
      const PASSWORD = _password.trim();
      const RULE_1 = {
        expression: !PASSWORD || PASSWORD === "",
        name: "password",
        msg: this.$i18n.t("public.views.Pages.Wizard.errors.erPwd"),
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp(
        "^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*)[0-9a-zA-Zd@$!%*#?&.]{6,}$"
      );
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(PASSWORD),
        name: "password",
        msg: this.$i18n.t("public.views.Pages.Wizard.errors.erPwd2"),
      };
      this.validatorStep1.addRule(RULE_1).addRule(RULE_2);
      this.notFirst();
    },
    checkPasswordConfirm(_passwordConfirm, _password) {
      const PASSWORDCONFIRM = _passwordConfirm.trim();
      const PASSWORD = _password.trim();
      const RULE_1 = {
        expression: !PASSWORDCONFIRM || PASSWORDCONFIRM === "",
        name: "passwordConfirm",
        msg: this.$i18n.t("public.views.Pages.Wizard.errors.erPwdConfirm"),
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp(
        "^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*)[0-9a-zA-Zd@$!%*#?&.]{6,}$"
      );
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(PASSWORDCONFIRM),
        name: "passwordConfirm",
        msg: this.$i18n.t("public.views.Pages.Wizard.errors.erPwd2"),
      };
      const RULE_3 = {
        expression: PASSWORDCONFIRM !== PASSWORD,
        name: "passwordConfirm",
        msg: this.$i18n.t("public.views.Pages.Wizard.errors.erPwdConfirm2"),
      };
      this.validatorStep1.addRule(RULE_1).addRule(RULE_2).addRule(RULE_3);
      this.notFirst();
    },
    checkFormStep1() {
      this.checkEmail(this.email);
      this.checkName(this.name);
      this.checkLastname(this.lastname);
      this.checkPassword(this.password);
      this.checkPasswordConfirm(this.passwordConfirm, this.password);
    },
    saveForm(evt) {
      evt.preventDefault();
      this.checkFormStep1();
      this.checkFormStep2();
      if (this.validatorStep1.errors.length === 0) {
        if (this.wizardType) {
          if (this.wizardType === "PROFESSIONAL") {
            this.saveInformationProfessional();
          } else if (this.wizardType === "PATIENT") {
            this.saveInformationPatient();
          } else {
            this.$notify({
              group: "notificacions",
              title: this.$i18n.t("public.views.Pages.Wizard.errors.erTitle"),
              text: this.$i18n.t("public.views.Pages.Wizard.errors.erStep1"),
              type: "error",
            });
          }
        } else {
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t("public.views.Pages.Wizard.errors.erTitle"),
            text: this.$i18n.t("public.views.Pages.Wizard.errors.erStep1"),
            type: "error",
          });
        }
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t("public.views.Pages.Wizard.errors.erTitle"),
          text: this.$i18n.t("public.views.Pages.Wizard.errors.erStep1"),
          type: "error",
        });
      }
    },
    //Form 2
    clickStep1(props) {
      this.titleWizard = this.$i18n.t(
        "public.views.Pages.Wizard.help.tab.tab1.title"
      );
      this.subtitleWizard = this.$i18n.t(
        "public.views.Pages.Wizard.help.tab.tab1.subtitle"
      );
      props.prevTab();
    },
    checkTimeZone(_timeZone) {
      const TIMEZONE = _timeZone.trim();
      const RULE_1 = {
        expression: !TIMEZONE || TIMEZONE === "",
        name: "timeZone",
        msg: this.$i18n.t("public.views.Pages.Wizard.errors.erTimeZone"),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkTown(_country) {
      const COUNTRY = _country.trim();
      const RULE_1 = {
        expression: !COUNTRY || COUNTRY === "",
        name: "town",
        msg: this.$i18n.t("public.views.Pages.Wizard.errors.erTown"),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkPostalCode(_country) {
      const COUNTRY = _country.trim();
      const RULE_1 = {
        expression: !COUNTRY || COUNTRY === "",
        name: "postalCode",
        msg: this.$i18n.t("public.views.Pages.Wizard.errors.erPostalCode"),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkCountry(_country) {
      const COUNTRY = _country.trim();
      const RULE_1 = {
        expression: !COUNTRY || COUNTRY === "",
        name: "country",
        msg: this.$i18n.t("public.views.Pages.Wizard.errors.erCountry"),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkCipGalatea(_item) {
      const ITEM = _item.trim();
      const RULE_1 = {
        expression: !ITEM || ITEM === "",
        name: "cipGalatea",
        msg: this.$i18n.t("public.views.Pages.Wizard.errors.erCipGalatea"),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkDocument(_document) {
      const DOCUMENT = _document.trim();
      const RULE_1 = {
        expression: !DOCUMENT || DOCUMENT === "",
        name: "document",
        msg: this.$i18n.t("public.views.Pages.Wizard.errors.erDocument"),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkAcceptConditions1(_acceptConditions1) {
      const ACCEPTCONDITIONS1 = _acceptConditions1;
      const RULE_1 = {
        expression: ACCEPTCONDITIONS1 === "false",
        name: "acceptConditions1",
        msg: this.$i18n.t(
          "public.views.Pages.Wizard.errors.erAcceptConditions1"
        ),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkAcceptConditionsGalatea1(_acceptConditions1) {
      const ACCEPTCONDITIONS1 = _acceptConditions1;
      const RULE_1 = {
        expression: ACCEPTCONDITIONS1 === "false",
        name: "acceptConditionsGalatea1",
        msg: this.$i18n.t(
          "public.views.Pages.Wizard.errors.erAcceptConditionsGalatea1"
        ),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkAcceptConditionsGalatea2(_acceptConditions) {
      const ACCEPTCONDITIONS = _acceptConditions;
      const RULE_1 = {
        expression: ACCEPTCONDITIONS === "false",
        name: "acceptConditionsGalatea2",
        msg: this.$i18n.t(
          "public.views.Pages.Wizard.errors.erAcceptConditionsGalatea2"
        ),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkAcceptConditionsGalatea3(_acceptConditions) {
      const ACCEPTCONDITIONS = _acceptConditions;
      const RULE_1 = {
        expression: ACCEPTCONDITIONS === "false",
        name: "acceptConditionsGalatea3",
        msg: this.$i18n.t(
          "public.views.Pages.Wizard.errors.erAcceptConditionsGalatea3"
        ),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkFormStep2() {
      this.checkTimeZone(this.timeZone);
      this.checkCountry(this.country);
      this.checkDocument(this.document);

      if (!this.isGalatea) {
        this.checkAcceptConditions1(this.acceptConditions1);
      } else if (this.wizardType === "PATIENT") {
        this.checkAcceptConditionsGalatea1(this.acceptConditionsGalatea1);
        this.checkAcceptConditionsGalatea2(this.acceptConditionsGalatea2);
        this.checkCipGalatea(this.cipGalatea);
      } else {
        this.checkAcceptConditions1(this.acceptConditions1);
      }
    },
    vdropzoneSuccess(file, response) {
      this.uuid = response.uuid;
      this.filename = response.name;
      this.getFile(response.uuid);
    },
    updatePhone(data) {
      this.phone = data.e164;
    },
    getAddressData: function (addressData, placeResultData, id) {
      this.address = placeResultData.formatted_address;
      this.country = addressData.country;
    },
    updateAddress(data) {
      this.address = data.newVal;
    },
    getFile(uuid) {
      let self = this;

      if (uuid) {
        utilsService
          .getFile(uuid)
          .then((response) => {
            if (response) {
              self.defaultAvatar = false;
              self.file = response.data.data;
            } else {
              self.defaultAvatar = true;
              self.file = require("../../assets/images/user/woman_profile.jpg");
            }
          })
          .catch(function (error) {
            self.defaultAvatar = true;
            self.file = require("../../assets/images/user/woman_profile.jpg");
          });
      } else {
        self.defaultAvatar = true;
        self.file = require("../../assets/images/user/woman_profile.jpg");
      }
    },
    getLogo(uuid) {
      let self = this;
      utilsService
        .getFile(uuid)
        .then((response) => {
          if (response) {
            self.defaultAvatarLogo = false;
            self.fileLogo = response.data.data;
          } else {
            self.defaultAvatarLogo = true;
            self.fileLogo = require("../../assets/images/logo.png");
          }
        })
        .catch(function (error) {
          self.defaultAvatarLogo = true;
          self.fileLogo = require("../../assets/images/logo.png");
        });
    },
    saveInformationPatient() {
      let obj = {
        email: this.email,
        name: this.name,
        lastname: this.lastname,
        password: this.password,
        passwordConfirm: this.passwordConfirm,
        acceptConditions: this.acceptConditions,
        uuid: this.uuid,
        filename: this.filename,
        document: this.document,
        language: this.language,
        phone: this.phone,
        country: this.country,
        address: this.address,
        postalCode: this.postalCode,
        town: this.town,
        timeZone: this.timeZone,
        currency: this.currency,
        acceptConditions1: this.acceptConditions1,
        acceptConditionsGalatea1: this.acceptConditionsGalatea1,
        acceptConditionsGalatea2: this.acceptConditionsGalatea2,
        acceptConditionsGalatea3: this.acceptConditionsGalatea3,
        cipGalatea: this.cipGalatea,
        organizationId: this.$route.query.organization
      };

      let self = this;

      this.$awn.asyncBlock(
        patientService.updatePublic(obj),
        (response) => {
          if (response) {
            this.login();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.updatePublic",
            module: "view-pages-wizard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              obj: obj
            })
          });
        },
        " "
      );
    },
    saveInformationProfessional() {
      let obj = {
        email: this.email,
        name: this.name,
        lastname: this.lastname,
        password: this.password,
        passwordConfirm: this.passwordConfirm,
        acceptConditions: this.acceptConditions,
        uuid: this.uuid,
        filename: this.filename,
        document: this.document,
        language: this.language,
        phone: this.phone,
        country: this.country,
        address: this.address,
        town: this.town,
        postalCode: this.postalCode,
        timeZone: this.timeZone,
        currency: this.currency,
        acceptConditions1: this.acceptConditions1,
      };

      let self = this;

      this.$awn.asyncBlock(
        professionalService.updatePublic(obj),
        (response) => {
          if (response) {
            this.login();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.updatePublic",
            module: "view-pages-wizard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              obj: obj
            })
          });
        },
        " "
      );
    },
    async getLogoOrganization() {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.findLogo(this.$route.query.organization),
        (response) => {
          if (response) {
            self.getLogo(response.data);
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.findLogo",
            module: "view-pages-wizard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organization: this.$route.query.organization
            })
          });
        }
      );
    },
    async findRoles(request) {
      let authentication = localStorage.getItem("authorization");

      authService
        .getRoles(authentication)
        .then((response) => {
          localStorage.setItem(
            "organizationRoles",
            JSON.stringify(response.data)
          );
          if (request.data.role === "PATIENT") {
            routes.push({
              name: "auth.patient.dashboard",
            });
          } else {
            routes.push({
              name: "auth.professional.dashboard",
            });
          }
        })
        .catch(function (error) {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem("authorization");
          } else if (error.response && error.response.status === 404) {
            localStorage.removeItem("authorization");
          } else if (error.response && error.response.status === 500) {
            localStorage.removeItem("authorization");
          } else {
            localStorage.removeItem("authorization");
          }
        });
    },
    login() {
      let user = {
        email: this.email,
        password: this.password,
        type: "APP",
      };

      let data = user;

      if (this.$device) {
        data.device = {
          accessClientName: "",
          accessClientType: "",
          accessClientVersion: "",
          accessDeviceBrand: "",
          accessDeviceType: "",
          accessClientOsName: "",
          accessClientOsVersion: "",
          accessClientOsPlatform: "",
        };
        if (this.$device.client) {
          data.device.accessClientName = this.$device.client.name;
          data.device.accessClientType = this.$device.client.type;
          data.device.accessClientVersion = this.$device.client.version;
        }
        if (this.$device.device) {
          data.device.accessDeviceBrand = this.$device.device.brand;
          data.device.accessDeviceType = this.$device.device.type;
        }
        data.device.accessClientOsName = this.$device.os_name.name;
        data.device.accessClientOsVersion = this.$device.os_version;
        data.device.accessClientOsPlatform = this.$device.os_platform;
      }

      let self = this;

      this.$awn.asyncBlock(
        authService.login(data),
        (response) => {
          if (response && response.data) {
            localStorage.setItem("authorization", response.data.token);
            localStorage.setItem("role", response.data.role);
            localStorage.setItem("userId", response.data.userId);
            localStorage.setItem("type", response.data.type);
            localStorage.setItem(
              "organizationId",
              response.data.organizationId
            );
            self.findRoles(response);
          } else {
            routes.push({
              name: "public.signin",
            });
          }
        },
        (error) => {
          if (error.response && error.response.status === 401) {
            self.showAlertError = true;
            self.user.password = "";
          } else if (error.response && error.response.status === 404) {
            routes.push({
              name: "public.signin",
            });
          } else if (error.response && error.response.status === 500) {
            routes.push({
              name: "public.signin",
            });
          } else {
            routes.push({
              name: "public.signin",
            });
          }
        },
        ""
      );
    },
  },
};
</script>
